import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

export const leaveEncashmentService = {
  getLeaveBalances: async (filterPayload, year) => {
    const payload = { filters: filterPayload, year };
    return await axios.post(`${domain}/api/LeaveEncashment/preview`, payload, { headers });
  },

  syncToPayroll: async (employeeIds, payrollPeriodId, year) => {
    const payload = { employeeIds, payrollPeriodId, year };
    return await axios.post(`${domain}/api/LeaveEncashment/sync-to-payroll`, payload, { headers });
  },

  syncToFinalPay: async (employeeIds, payrollPeriodId, year) => {
    const payload = { employeeIds, payrollPeriodId, year };
    return await axios.post(`${domain}/api/LeaveEncashment/sync-to-final-pay`, payload, { headers });
  },

};